@if (!isDetailFooter) {
<div class="flex items-center justify-between gap-3 border-t border-[#2525254D] dark:border-white/30 py-3">
  <h6 class="text-xs font-medium dark:text-white">Privacy Policy</h6>
  <h2 class="text-[32px] font-bold dark:text-white">Vota</h2>
</div>}

@if(isDetailFooter) {
<!-- <div class="fixed bottom-0 left-0 right-0 flex items-center justify-between gap-3 border-t border-[#2525254D] dark:border-white/30 py-3">
  <div class="flex items-center gap-2 px-4">
    <img src="../../../../assets/images/logo.png" />
    ©{{year}} Vota. All rights reserved.
  </div>
  <div class="flex flex-row gap-4 px-4">
      <ul>
        Company
        <li>About us</li>
      </ul>
      <ul>
        Legal
        <li>Terms and Conditions</li>
        <li>Privacy & Cookies Policy</li>
      </ul>
  </div>
</div> -->

<footer class="border-t border-gray-200 min-[900px]:py-2 py-4 px-4 text-sm bg-[#3D3D3D] text-white">
  <div class="mx-auto flex flex-col min-[900px]:flex-row justify-between items-start min-[900px]:items-center gap-6">
    <div class="flex items-center gap-4">
      <img src="../../../../assets/images/logo.png" alt="Logo" class="h-14" />
      <p>©{{year}} Vota. All rights reserved.</p>
    </div>
    <div class="flex flex-col min-[900px]:flex-row min-[900px]:gap-6 gap-3">
      <a href="#" class="hover:underline">About us</a>
      <a href="#" class="hover:underline">Legal</a>
      <a href="#" class="hover:underline">Terms and Conditions</a>
      <a href="#" class="hover:underline">Privacy & Cookies Policy</a>
    </div>
    
  </div>
  <!-- <div class="text-center border-t border-white/15 mt-4 pt-3 pb-1">
    <p>©{{year}} Vota. All rights reserved.</p>
  </div> -->
</footer>

}